export default class ListWorkDaysController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, $timeout, $interval,
    workDays, moment,
    uiCalendarConfig
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$interval = $interval;
    this.workDays = workDays;
    this.events = [];
    this.eventSources = [];
    this.moment = moment;
    this.uiCalendarConfig = uiCalendarConfig;
    this.uiConfig = {
      calendar: {
        height: 600,
        lang: 'pl',
        locale: 'pl',
        minTime: '06:00:00',
        maxTime: '23:59:00',
        timeFormat: 'HH:mm',
        allDaySlot: false,
        slotLabelFormat: 'HH:mm',
        slotDuration: '00:30:00',
        defaultDate: this.moment(),
        defaultView: 'agendaWeek',
        handleWindowResize: false,
        aspectRatio: 1,
        header: {
          left: 'title',
          center: '',
          right: 'today prev,next'
        },
        weekends: true
      }
    };
    this.loadAllEvents();
    this.$timeout(() => {
      this.renderCalendar();
    }, 500);
  }

  renderCalendar() {
    if (angular.isUndefined(this.uiCalendarConfig.calendars.mainCalendar)) {
      this.$interval(() => {
        this.uiCalendarConfig.calendars.mainCalendar.fullCalendar('render');
        this.renderCalendar();
      }, 300);
    } else {
      this.uiCalendarConfig.calendars.mainCalendar.fullCalendar('render');
    }
  }

  loadAllEvents() {
    this.events = this.workDays;
    this.eventSources.push(this.events);
  }

  edit() {
    this.$mdDialog.hide();
    this.$state.go('modules.settings.step2');
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
